import {GuidePostSerializer} from "@oldDashboard/legacyModels/serializers/guidePostSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";

export class CommandGetAffiliates {

    //TODO CHECK SERIALIZER
    //TODO CONFIGURE URLS IN A FILE
    async run() {
        const path = `affiliates/`
        try {
            const request = await legacyReportingGet(path);
            
            return request;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }

    deserialize(data: any) {
        const serializer = new GuidePostSerializer();
        return serializer.deserializeList(data);
    }
}

